/**
 * Format the given date, to the given format
 */
export function formatDate(date: Date, format: 'yyyy-mm-dd'): string {
  switch (format) {
    case 'yyyy-mm-dd':
      return formatYearMonthDate(date);
  }
}

/**
 * Convert date to yyyy-mm-dd
 */
function formatYearMonthDate(date: Date): string {
  return date.toLocaleDateString('sv-SE');
}

/**
 * Get a date object at the end of the current year
 */
export function endOfYear(year?: number): Date {
  return new Date(year ?? new Date().getFullYear(), 11, 31, 23, 59, 59, 999);
}

/**
 * Takes a given date and returns the very end of that date.
 */
export function endOfDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(23, 59, 59, 999);
  return result;
}

/**
 * Takes a given date and appends `numberOfDaysToAdd`.
 */
export function addDays(date: Date, numberOfDaysToAdd: number) {
  const result = new Date(date);
  result.setDate(date.getDate() + numberOfDaysToAdd);
  return result;
}

/**
 * Get a date object at the start of the current year
 */
export function startOfYear(year?: number): Date {
  return new Date(year ?? new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
}

/**
 * Takes a year, e.g. `2025` and compare it againt the current year.
 */
export function isCurrentYear(year: number): boolean {
  if (!year) {
    return false;
  }

  if (!Number.isInteger(year)) {
    return false;
  }

  return year === new Date().getFullYear();
}

/**
 * Returns the current year as a number.
 */
export function getCurrentYear(): number {
  return new Date().getFullYear();
}
